import { useRouter } from "next/router";
import { Box } from "@chakra-ui/react";
import { useState } from "react";
import BaseLayout from "../../components/base_layout";
import Loading from "../../components/Loading";
import { lifecycleNew } from "../../provider/common";
import { NextSeo } from "next-seo";
//컴포넌트
import SearchEmpty from "../../components/searchFigma/SearchEmpty";
import SearchError from "../../components/searchFigma/SearchError";
// 신규
import CategoryNav from "../../components/searchFigma/CategoryNav";
import ResultList from "../../components/searchFigma/ResultList";
import ResultListItem from "../../components/searchFigma/ResultListItem";
// Hook
import useSearchList from "../../hooks/useSearchList";
// css module
import styles from "../../styles/components/searchFigma/List.module.css";
import ResultListMobile from "../../components/searchFigma/ResultListMobile";
import PickOneModal from "../../components/searchFigma/PickOneModal";
import PickMultiModal from "../../components/searchFigma/PickMultiModal";
import ResultListItemMobile from "../../components/searchFigma/ResultListItemMobile";

// 전역변수
const axios = require("axios").default;

export default function SearchList() {
  const router = useRouter();

  // ✅ 메타서치 납기순 재고순 검색어 등에 모달 상태를 부모에서 관리
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [isModalMultiManufacturerOpen, setIsModalMultiManufacturerOpen] =
    useState(false);
  const openModalMultiManufacturer = () =>
    setIsModalMultiManufacturerOpen(true);
  const closeModalMultiManufacturer = () =>
    setIsModalMultiManufacturerOpen(false);

  const [isModalMultiDistributorOpen, setIsModalMultiDistributorOpen] =
    useState(false);
  const openModalMultiDistributor = () => setIsModalMultiDistributorOpen(true);
  const closeModalMultiDistributor = () =>
    setIsModalMultiDistributorOpen(false);

  const { keyword } = router.query;
  const {
    datas,
    filterListManu,
    filterListSrc,
    loadingShow,
    searchShow,
    noneSearchShow,
    searchError,
    isLogin,
    handleFilterSearchFigma,
    handleSortChangeFigma,
    member,
  } = useSearchList(router, keyword);

  const capitalize = (str) => {
    if (!str || typeof str !== "string") return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <>
      <NextSeo
        title={
          keyword.startsWith("%")
            ? decodeURIComponent(keyword)
            : keyword + " - 실시간 재고 검색"
        }
        description={
          keyword.startsWith("%")
            ? decodeURIComponent(keyword)
            : keyword + " 가격비교, 재고확인, 데이터시트, 전자부품 쇼핑몰"
        }
        canonical={
          process.env.PANDA_LIVE_URL +
          "/search/lists?keyword=" +
          keyword.startsWith("%")
            ? keyword
            : encodeURIComponent(keyword)
        }
        openGraph={{
          title: keyword.startsWith("%")
            ? decodeURIComponent(keyword)
            : keyword + " - 실시간 재고 검색",
          description: keyword.startsWith("%")
            ? decodeURIComponent(keyword)
            : keyword + " 가격비교, 재고확인, 데이터시트, 전자부품 쇼핑몰",

          url:
            process.env.PANDA_LIVE_URL +
            "/search/lists?keyword=" +
            keyword.startsWith("%")
              ? keyword
              : encodeURIComponent(keyword),
        }}
      />
      <BaseLayout>
        <Loading loadingShow={loadingShow} />
        {/* 단일 선택 */}
        <PickOneModal
          isOpen={isModalOpen}
          closeModal={closeModal}
          handleSortChange={handleSortChangeFigma}
        />
        <PickMultiModal
          isOpen={isModalMultiManufacturerOpen}
          closeModal={closeModalMultiManufacturer}
          onFilterApply={handleFilterSearchFigma}
          options={filterListManu}
          type="manufacturer"
        />
        <PickMultiModal
          isOpen={isModalMultiDistributorOpen}
          closeModal={closeModalMultiDistributor}
          onFilterApply={handleFilterSearchFigma}
          options={filterListSrc}
          type="distributor"
        />
        {/* 다중 선택 */}
        <Box
          className={
            noneSearchShow === true || searchError === true
              ? "search-hidden"
              : ""
          }
        >
          <Box className={styles.desktopWhite}>
            <Box className={styles.search_container}>
              {/* ============ 검색결과 데이터가 있을때  ============*/}
              {/* 신규 필터 */}
              <CategoryNav
                manufacturerLists={filterListManu}
                distributorLists={filterListSrc}
                onFilterApply={handleFilterSearchFigma}
              />
            </Box>
          </Box>
        </Box>
        <Box className={styles.desktopGray}>
          <Box className={styles.search_container}>
            {/* 신규 검색결과 모바일 필터 */}
            <ResultListMobile
              parts={datas}
              onOpenModal={openModal}
              onOpenModalMultiManufacturer={openModalMultiManufacturer}
              onOpenModalMultiDistributor={openModalMultiDistributor}
            />
            {/* 신규 검색결과 필터 */}
            <ResultList
              parts={datas}
              handleSortChange={handleSortChangeFigma}
            />
            <ResultListItemMobile
              parts={datas}
              lifecycle={lifecycleNew}
              capitalize={capitalize}
              isLogin={isLogin}
              keyword={keyword}
              member={member}
              handleSortChange={handleSortChangeFigma}
            />
            <ResultListItem
              parts={datas}
              lifecycle={lifecycleNew}
              capitalize={capitalize}
              isLogin={isLogin}
              keyword={keyword}
              member={member}
              handleSortChange={handleSortChangeFigma}
            />
          </Box>
          {/* ============ 검색결과 데이터가 없을때  ============*/}
          <Box className={noneSearchShow ? "" : "search-hidden"}>
            <SearchEmpty keyword={keyword} isLogin={isLogin} />
          </Box>
          {/* ============ 검색결과 에러가 생길때  ============*/}
          <Box className={searchError ? "" : "search-hidden"}>
            <SearchError keyword={keyword} isLogin={isLogin} />
          </Box>
        </Box>
      </BaseLayout>
    </>
  );
}
